import { render, staticRenderFns } from "./approvalRecord.vue?vue&type=template&id=79a45a60&scoped=true"
import script from "./approvalRecord.vue?vue&type=script&lang=js"
export * from "./approvalRecord.vue?vue&type=script&lang=js"
import style0 from "./approvalRecord.vue?vue&type=style&index=0&id=79a45a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a45a60",
  null
  
)

export default component.exports